import { render } from "./FormSakit.vue?vue&type=template&id=c30efa0c"
import script from "./FormSakit.vue?vue&type=script&lang=js"
export * from "./FormSakit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__